var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bd-auth"}},[_c('el-container',[_c('el-main',[_c('transition',{attrs:{"mode":"out-in","enter-active-class":"fadeIn","leave-active-class":"fadeOut","appear":""}},[_c('router-view',{staticClass:"animated"})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }